import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import SocketInit from './utils/socketConfig';
import { Router } from 'react-router-dom';
import store from './store';
import App from './App';

import * as serviceWorker from './serviceWorker';
import './index.sass';
import './style/antdTheme.less';
import history from './utils/history';

SocketInit();

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want your devices to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
